import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BadgeSharedComponent } from './badge.component';

@NgModule({
    declarations: [
        BadgeSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        BadgeSharedComponent
    ]
})

export class BadgeSharedModule {}
